import styled from "styled-components";

const Link = styled.a`
  color: ${_ => _.theme.colors.accentGreen};
  font-weight: 600;
  text-decoration: none;
`;

export default Link;
